type ToastKind = 'success' | 'info' | 'warn' | 'danger';

interface ToastPayload {
  id: number;
  title: string;
  body?: string;
  kind: ToastKind;
}

const listeners = new Set<(t: ToastPayload) => void>();
let nextId = 1;

export function onToast(cb: (t: ToastPayload) => void) {
  listeners.add(cb);
  return () => listeners.delete(cb);
}

function emit(kind: ToastKind, title: string, body?: string) {
  const payload: ToastPayload = { id: nextId++, title, body, kind };
  listeners.forEach((l) => l(payload));
}

// Callable directly: toast('saved', 'details', 'success')
function toastFn(title: string, body?: string, kind: ToastKind = 'success') {
  emit(kind, title, body);
}

// Also exposes .success / .error / .info / .warn for modern callers
export const toast = Object.assign(toastFn, {
  success: (title: string, body?: string) => emit('success', title, body),
  info: (title: string, body?: string) => emit('info', title, body),
  warn: (title: string, body?: string) => emit('warn', title, body),
  error: (title: string, body?: string) => emit('danger', title, body),
  danger: (title: string, body?: string) => emit('danger', title, body),
});
